import { render, staticRenderFns } from "./Atendimento_Atendimentos.vue?vue&type=template&id=7f4561e0&scoped=true&"
import script from "./Atendimento_Atendimentos.vue?vue&type=script&lang=js&"
export * from "./Atendimento_Atendimentos.vue?vue&type=script&lang=js&"
import style0 from "./Atendimento_Atendimentos.vue?vue&type=style&index=0&id=7f4561e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4561e0",
  null
  
)

export default component.exports